import React, { useCallback, useContext, useState } from 'react';

import Deal from './Deal';
import { BoxProps } from '../../../../Components/UI/Box';
import { canOpenNavigationForDeal } from '../../../../Utils/canOpenNavigation';
import { DealContext } from '../../Context';
import MobileNavigation from '../MobileNavigation';

const DealsMobileNavigation: React.FC<BoxProps> = (props) => {
  const { deal } = useContext(DealContext);
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <MobileNavigation
      onOpen={canOpenNavigationForDeal(deal) ? toggleMenu : undefined}
      onClose={toggleMenu}
      isOpen={isOpen}
      department={deal?.department}
      client={deal?.client}
      {...props}
    >
      {deal && <Deal key={deal.id} deal={deal} initiallyCollapsed={false} onQuotationClick={toggleMenu} />}
    </MobileNavigation>
  );
};

export default DealsMobileNavigation;
